// Приветственные токены за регистрацию — с бэка (настройка «Общих настроек»
// админки тарифов, GET /auth/config). null = ответ ещё не пришёл: бейдж не
// рендерим, чтобы не мигать фолбэком до загрузки. 0 = бонус выключен —
// бейдж и уведомление скрываются (решение владельца 2026-08-08). Сбой сети
// или старый бэк → прежний хардкод 40.
import { useAuthConfig } from './useAuthConfig'

export function useWelcomeCredits(): number | null {
	const config = useAuthConfig()
	return config ? config.welcomeCredits : null
}
